import {Component, OnInit} from '@angular/core';
import {CreateFileRequestDialogComponent} from '../shared/create-file-request-dialog/create-file-request-dialog.component';
import {MatDialog} from '@angular/material/dialog';
import {RequestFileService} from '../../_services/api/request-file.service';
import {itemAnimation, listAnimation} from '../../_animations/listItem';
import {concat} from 'rxjs';
import {ConfirmationDialogComponent} from '../shared/confirmation-dialog/confirmation-dialog.component';
import {LoadingDialogComponent} from '../shared/loading-dialog/loading-dialog.component';
import {HttpEvent, HttpEventType} from '@angular/common/http';
import {MatSnackBar} from '@angular/material/snack-bar';
import {saveAs} from 'file-saver';
import {ActivatedRoute, Router} from '@angular/router';
import {FileService} from '../../_services/api/file.service';

@Component({
  selector: 'app-requests-list-view',
  templateUrl: './requests-list-view.component.html',
  styleUrls: ['./requests-list-view.component.scss'],
  animations: [listAnimation, itemAnimation]
})
export class RequestsListViewComponent implements OnInit {

  loading: boolean;
  requestedFiles: any;
  currentlyShowing: 'created' | 'files_added';
  isAllSelected: boolean;
  currentlySelected: number;

  constructor(private dialog: MatDialog, private requestFile: RequestFileService, private snackBar: MatSnackBar,
              private route: ActivatedRoute, private router: Router, private fileService: FileService) {
    this.loading = true;
    this.currentlyShowing = 'created';
    this.currentlySelected = 0;
    this.isAllSelected = false;
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      if (params.download) {
        this.requestFile.get('files_added').subscribe( res => {
          this.requestedFiles = res;
          this.loading = false;
          const item = this.requestedFiles.find(x => x.uuid === params.download);

          if (item){
            this.download(item.uuid);
            this.router.navigate([], {
              queryParams: {
                download: null
              },
              queryParamsHandling: 'merge'
            });
            setTimeout(() => {
              this.currentlyShowing = 'files_added';
              this.getRequests(this.currentlyShowing);
              }, 500);
          } else {
            this.router.navigate([], {
              queryParams: {
                download: null
              },
              queryParamsHandling: 'merge'
            });
          }
        });

      } else {
        this.getRequests('created');
      }
    });

  }

  showRequestedFiles(name: 'created' | 'files_added'){
    if (this.currentlyShowing !== name){
      this.currentlyShowing = name;
      this.getRequests(this.currentlyShowing);
    }
  }

  openSendRequestDialog(){
    const createShareFileDialog = this.dialog.open(CreateFileRequestDialogComponent, {
      width: '90%',
      maxWidth: '635px',
    });

    createShareFileDialog.afterClosed().subscribe( res => {
      this.getRequests(this.currentlyShowing);
    });
  }

  getRequests(status: 'created' | 'files_added'){
    this.loading = true;
    this.requestFile.get(status).subscribe( res => {
      this.requestedFiles = res;
      this.loading = false;
      this.checkShareItems();
    });
  }

  checkShareItems() {
    this.currentlySelected = this.requestedFiles.filter(res => res.is_selected).length;
    this.isAllSelected = this.currentlySelected === this.requestedFiles.length;
  }

  deleteSelected(): void {
    if (this.currentlySelected > 0) {
      const message = 'Are you sure, you want to remove selected files?';

      const confirmDialog = this.dialog.open(ConfirmationDialogComponent, {
        data: {
          title: 'Confirm deleting set of documents',
          message,
          confirm: 'Delete'
        }
      });
      confirmDialog.afterClosed().subscribe(result => {
        if (result === true) {

          const loadingDialog = this.dialog.open(LoadingDialogComponent, {
            data: {
              loaderType: 'deleting-file',
              label: 'Deleting files'
            }, disableClose: true
          });
          const requests = this.requestedFiles.filter(res => res.is_selected).map(res => this.requestFile.delete(res.uuid));
          const lastUuid = this.requestedFiles.filter(res => res.is_selected).map(res => res.uuid)[requests.length - 1];

          concat(...requests).subscribe( (res: any) => {
            if (res.uuid === lastUuid){
              this.getRequests(this.currentlyShowing);
              loadingDialog.close();
            }
          });
        }
      });
    }
  }

  handleAction(eventType){
    switch (eventType){
      case 'selectAll':
        this.requestedFiles.forEach( res => res.is_selected = true);
        this.checkShareItems();
        break;
      case 'delete':
        this.deleteSelected();
        break;
      case 'clearSelection':
        this.requestedFiles.forEach( res => res.is_selected = false);
        this.checkShareItems();
        break;
    }
  }

  download(token: string){
    const queueId = Math.random().toString(36).slice(2, 7);
    const confirmDialog = this.dialog.open(LoadingDialogComponent, {
      data: {
        loaderType: 'file-packing',
        label: 'Preparing your files',
        status: 0, queueId
      }, disableClose: true
    });

    const item = this.requestedFiles.find(x => x.uuid === token);

    this.requestFile.download(token, 'queueId').subscribe((event: HttpEvent<any>) => {
        switch (event.type) {
          case HttpEventType.DownloadProgress:
            confirmDialog.componentInstance.data.label = 'Downloading...';
            confirmDialog.componentInstance.data.status = (event.loaded / event.total) * 100;
            break;
          case HttpEventType.Response:
            const response = event.body;
            const blob = new Blob([response], {
              type: response.type
            });
            const filename = this.fileService.getFileName();
            item.last_opened_at = new Date();
            saveAs(blob, filename);
            confirmDialog.close();
        }
      }, error => {
        this.snackBar.open('Error on downloading.', 'close', {
          duration: 2000,
        });
        confirmDialog.close();
      },
      () => {
        confirmDialog.close();
      });
  }
}
